export default __webpack_public_path__ + "static/media/mk.1cb13922.jpg";